import { RESPONSE_CARS_TYPES, REQUEST_CARS_TYPES_FAILURE } from "../actions/carsTypesActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  types: [],
};

const carsTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CARS_TYPES: {
      return Object.assign({}, state, {
        dataState: queriesStates.READY,
        types: action.data,
      });
    }
    case REQUEST_CARS_TYPES_FAILURE: {
      return Object.assign({}, state, {
        dataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }
    default:
      return state;
  }
};

export default carsTypesReducer;
